export const MIX_SUMMARY = {
  totalExpectedGain: 6310186,
  groupsCount: 343,
  highestGain: 356351,
};

export const MIX_GROUPS = [
  { id: "pratos-prontos",           name: "Pratos Prontos",           expectedGain: 356351, skuCount: 60,  planCount: 10 },
  { id: "carne-aves-resfriadas",    name: "Carne de Aves Resfriadas", expectedGain: 268000, skuCount: 56,  planCount: 10 },
  { id: "carne-bovinos-vacuo",      name: "Carne Bovinos Vacuo",      expectedGain: 252000, skuCount: 42,  planCount: 10 },
  { id: "bovinos-cortes-traseiros", name: "Bovinos Cortes Traseiros", expectedGain: 221000, skuCount: 48,  planCount: 9  },
  { id: "balas-e-doces",            name: "Balas e Doces",            expectedGain: 203000, skuCount: 164, planCount: 10 },
];

export const TIER_FILTER_TAGS = [
  { key: "nucleo",           label: "Núcleo",            color: "#16a34a", hasTag: true  },
  { key: "top_rede",         label: "Top da rede",       color: "#666666", hasTag: false },
  { key: "medias_mais",      label: "Médias+",           color: "#2563eb", hasTag: true  },
  { key: "medio_desempenho", label: "Médio desempenho",  color: "#666666", hasTag: false },
  { key: "grande",           label: "Grande",            color: "#7c3aed", hasTag: true  },
  { key: "lojas_grandes",    label: "Lojas grandes",     color: "#666666", hasTag: false },
  { key: "fora",             label: "Fora",              color: "#999999", hasTag: true  },
  { key: "cauda_longa",      label: "Cauda longa",       color: "#666666", hasTag: false },
];


export const TIER_BADGE_STYLE = {
  Núcleo:      { color: "#16a34a", bg: "rgba(22,163,74,0.08)", border: "rgba(22,163,74,0.3)" },
  Crescimento: { color: "#2563eb", bg: "rgba(37,99,235,0.08)", border: "rgba(37,99,235,0.3)" },
  Cauda:       { color: "#999999", bg: "rgba(153,153,153,0.08)", border: "rgba(153,153,153,0.3)" },
};

export const STORE_TIER_STYLE = {
  Grande:  { color: "#7c3aed", bg: "rgba(124,58,237,0.08)", border: "rgba(124,58,237,0.3)" },
  Média:   { color: "#2563eb", bg: "rgba(37,99,235,0.08)",  border: "rgba(37,99,235,0.3)"  },
  Pequena: { color: "#16a34a", bg: "rgba(22,163,74,0.08)",  border: "rgba(22,163,74,0.3)"  },
};

export const MIX_GROUP_DETAILS = {
  "pratos-prontos": {

    insight: {
      expectedGain: 356351,
      shareOfTotalGain: 0.056, // 5.6%
      skuCount: 60,
      storesAnalyzed: 10,
    },

    ranking: [
      { rank: 1,  name: "Sobre Coxa Assada Rotisseria Kg",      networkSales: 1136257, storesWithProduct: 10, totalStores: 10, tier: "Núcleo" },
      { rank: 2,  name: "Salsichao Assado Rotisseria Kg",       networkSales: 513128,  storesWithProduct: 10, totalStores: 10, tier: "Núcleo" },
      { rank: 3,  name: "Choripan Rotisseria Kg",               networkSales: 455201,  storesWithProduct: 10, totalStores: 10, tier: "Núcleo" },
      { rank: 4,  name: "Polenta Frita Rotisseria Kg",          networkSales: 308825,  storesWithProduct: 10, totalStores: 10, tier: "Núcleo" },
      { rank: 5,  name: "Pizza Calabresa Assada Rotisseria Un", networkSales: 241300,  storesWithProduct: 10, totalStores: 10, tier: "Núcleo" },
      { rank: 6,  name: "Panqueca Carne Rotisseria Kg",         networkSales: 198450,  storesWithProduct: 10, totalStores: 10, tier: "Núcleo" },
      { rank: 7,  name: "Pizza Mussar Assada Rotisseria Un",    networkSales: 176900,  storesWithProduct: 9,  totalStores: 10, tier: "Crescimento" },
      { rank: 8,  name: "Frango Assado Rotisseria Kg",          networkSales: 132103,  storesWithProduct: 9,  totalStores: 10, tier: "Crescimento" },
      { rank: 9,  name: "Lasanha Bolonhesa Cs 350G",            networkSales: 118700,  storesWithProduct: 8,  totalStores: 10, tier: "Crescimento" },
      { rank: 10, name: "Costela Suina Assada Rotisseria Kg",   networkSales: 97650,   storesWithProduct: 8,  totalStores: 10, tier: "Cauda" },
    ],

    stores: [
      {
        id: 1, name: "Loja 1", tier: "Grande",
        currentSkuCount: 60, idealSkuCount: 60,
        currentMix: [
          { rank: 1, name: "Sobre Coxa Assada Rotisseria Kg" },
          { rank: 2, name: "Salsichao Assado Rotisseria Kg" },
          { rank: 3, name: "Choripan Rotisseria Kg" },
          { rank: 4, name: "Polenta Frita Rotisseria Kg" },
        ],
        futureMix: [
          { rank: 1, name: "Sobre Coxa Assada Rotisseria Kg", status: null },
          { rank: 2, name: "Salsichao Assado Rotisseria Kg", status: null },
          { rank: 3, name: "Choripan Rotisseria Kg", status: null },
          { rank: 4, name: "Polenta Frita Rotisseria Kg", status: null },
        ],
        actions: [], 
      },
      {
        id: 2, name: "Loja 2", tier: "Média",
        currentSkuCount: 20, idealSkuCount: 26,
        currentMix: [
          { rank: 1,  name: "Sobre Coxa Assada Rotisseria Kg" },
          { rank: 2,  name: "Salsichao Assado Rotisseria Kg" },
          { rank: 3,  name: "Choripan Rotisseria Kg" },
          { rank: 4,  name: "Polenta Frita Rotisseria Kg" },
          { rank: 5,  name: "Pizza Calabresa Assada Rotisseria Un" },
          { rank: 6,  name: "Panqueca Carne Rotisseria Kg" },
          { rank: 7,  name: "Pizza Mussar Assada Rotisseria Un" },
          { rank: 9,  name: "Lasanha Bolonhesa Cs 350G" },
          { rank: 10, name: "Costela Suina Assada Rotisseria Kg" },
          { rank: 13, name: "Lasanha 4 Qjo Cs 350G" },
          { rank: 20, name: "Arroz Cozido Rotisseria Kg" },
          { rank: 50, name: "Salsicha Oderich 160G Peritif", status: "removed" },
        ],
        futureMix: [
          { rank: 1,  name: "Sobre Coxa Assada Rotisseria Kg", status: null },
          { rank: 2,  name: "Salsichao Assado Rotisseria Kg", status: null },
          { rank: 3,  name: "Choripan Rotisseria Kg", status: null },
          { rank: 4,  name: "Polenta Frita Rotisseria Kg", status: null },
          { rank: 5,  name: "Pizza Calabresa Assada Rotisseria Un", status: null },
          { rank: 6,  name: "Panqueca Carne Rotisseria Kg", status: null },
          { rank: 7,  name: "Pizza Mussar Assada Rotisseria Un", status: null },
          { rank: 8,  name: "Frango Assado Rotisseria Kg", status: "new" },
          { rank: 9,  name: "Lasanha Bolonhesa Cs 350G", status: null },
          { rank: 10, name: "Costela Suina Assada Rotisseria Kg", status: null },
          { rank: 11, name: "Bife Carne Milanesa Rotisseria Kg", status: "new" },
          { rank: 12, name: "Massa Bolognesa Rotisseria Kg", status: "new" },
          { rank: 13, name: "Lasanha 4 Qjo Cs 350G", status: null },
          { rank: 15, name: "Sanduiche Natural Cs Kg", status: "new" },
          { rank: 16, name: "Panqueca Frango Rotisseria Kg", status: "new" },
          { rank: 18, name: "Feijao Cozido Rotisseria Kg", status: "new" },
          { rank: 19, name: "Massa Matriciana Cs Kg", status: "new" },
          { rank: 20, name: "Arroz Cozido Rotisseria Kg", status: null },
          { rank: 25, name: "Prato Feito Carne Cs Kg", status: "review" },
          { rank: 30, name: "Strogonoff Fgo Arroz Bco 300G", status: "review" },
          { rank: 36, name: "Feijao Preto Pronto Fugini 250G", status: "review" },
          { rank: 39, name: "Salsicha Oderich 180G Viena", status: "review" },
          { rank: 43, name: "Feijoada Oderich 420G", status: "review" },
        ],
        actions: [
          { rank: 8,  type: "new",     name: "Frango Assado Rotisseria Kg",       storeRevenue: 13934, networkRevenue: 132103 },
          { rank: 11, type: "new",     name: "Bife Carne Milanesa Rotisseria Kg", storeRevenue: 11321, networkRevenue: 107330 },
          { rank: 12, type: "new",     name: "Massa Bolognesa Rotisseria Kg",     storeRevenue: 9409,  networkRevenue: 89206  },
          { rank: 15, type: "new",     name: "Sanduiche Natural Cs Kg",           storeRevenue: 5498,  networkRevenue: 52124  },
          { rank: 16, type: "new",     name: "Panqueca Frango Rotisseria Kg",     storeRevenue: 5436,  networkRevenue: 51536  },
          { rank: 18, type: "new",     name: "Feijao Cozido Rotisseria Kg",       storeRevenue: 5062,  networkRevenue: 48064  },
          { rank: 19, type: "new",     name: "Massa Matriciana Cs Kg",            storeRevenue: 4248,  networkRevenue: 40347  },
          { rank: 50, type: "removed", name: "Salsicha Oderich 160G Peritif",     storeRevenue: 93,    networkRevenue: 2517   },
          { rank: 25, type: "review",  name: "Prato Feito Carne Cs Kg",           storeRevenue: 1188,  networkRevenue: 22561  },
          { rank: 30, type: "review",  name: "Strogonoff Fgo Arroz Bco 300G",     storeRevenue: 547,   networkRevenue: 12107  },
          { rank: 36, type: "review",  name: "Feijao Preto Pronto Fugini 250G",   storeRevenue: 172,   networkRevenue: 7849   },
          { rank: 39, type: "review",  name: "Salsicha Oderich 180G Viena",       storeRevenue: 204,   networkRevenue: 6428   },
          { rank: 43, type: "review",  name: "Feijoada Oderich 420G",             storeRevenue: 89,    networkRevenue: 5413   },
        ],
      },

      { id: 3,  name: "Loja 3",  tier: "Pequena", currentSkuCount: 16, idealSkuCount: 20, currentMix: [], futureMix: [], actions: [], summaryFallback: { expectedRevenue: 33164, newCount: 5, removedCount: 1, reviewCount: 4 } },
      { id: 6,  name: "Loja 6",  tier: "Média",   currentSkuCount: 17, idealSkuCount: 25, currentMix: [], futureMix: [], actions: [], summaryFallback: { expectedRevenue: 56993, newCount: 9, removedCount: 1, reviewCount: 5 } },
      { id: 7,  name: "Loja 7",  tier: "Média",   currentSkuCount: 22, idealSkuCount: 27, currentMix: [], futureMix: [], actions: [], summaryFallback: { expectedRevenue: 34958, newCount: 7, removedCount: 2, reviewCount: 7 } },
      { id: 9,  name: "Loja 9",  tier: "Média",   currentSkuCount: 27, idealSkuCount: 28, currentMix: [], futureMix: [], actions: [], summaryFallback: { expectedRevenue: 25598, newCount: 4, removedCount: 3, reviewCount: 8 } },
      { id: 10, name: "Loja 10", tier: "Média",   currentSkuCount: 18, idealSkuCount: 25, currentMix: [], futureMix: [], actions: [], summaryFallback: { expectedRevenue: 51531, newCount: 8, removedCount: 1, reviewCount: 5 } },
    ],
  },
};

export const computeStoreTotals = (store) => {
  const actions = store.actions || [];

  if (actions.length > 0) {
    const sumBy = (type) => actions.filter(a => a.type === type).reduce((s, a) => s + a.storeRevenue, 0);
    const countBy = (type) => actions.filter(a => a.type === type).length;

    const inclusions = sumBy("new");
    const reviews = sumBy("review");

    return {
      newCount: countBy("new"),
      removedCount: countBy("removed"),
      reviewCount: countBy("review"),
      // receita projetada = só inclusões + avaliações (realocações não entram mais)
      expectedRevenue: inclusions + reviews,
      breakdown: { inclusions, reviews },
    };
  }

  const fallback = store.summaryFallback || {};
  return {
    newCount: fallback.newCount ?? 0,
    removedCount: fallback.removedCount ?? 0,
    reviewCount: fallback.reviewCount ?? 0,
    expectedRevenue: fallback.expectedRevenue ?? 0,
    breakdown: null, 
  };
};
